import { render, staticRenderFns } from "./SampleOrderList.vue?vue&type=template&id=42f39354&scoped=true"
import script from "./SampleOrderList.vue?vue&type=script&lang=js"
export * from "./SampleOrderList.vue?vue&type=script&lang=js"
import style0 from "./SampleOrderList.vue?vue&type=style&index=0&id=42f39354&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f39354",
  null
  
)

export default component.exports